import { render } from "./AddNewLocation.vue?vue&type=template&id=7ae25eea"
import script from "./AddNewLocation.vue?vue&type=script&lang=js"
export * from "./AddNewLocation.vue?vue&type=script&lang=js"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__